/* empty css               */
const e = {
  modifiers: {
    grid: "pf-m-grid",
    expandable: "pf-m-expandable",
    expanded: "pf-m-expanded",
    selected: "pf-m-selected",
    compact: "pf-m-compact",
    noPadding: "pf-m-no-padding",
    hoverable: "pf-m-hoverable",
    nowrap: "pf-m-nowrap",
    fitContent: "pf-m-fit-content",
    truncate: "pf-m-truncate",
    gridMd: "pf-m-grid-md",
    gridLg: "pf-m-grid-lg",
    gridXl: "pf-m-grid-xl",
    grid_2xl: "pf-m-grid-2xl"
  }
};
export {
  e as default
};
